import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";
import { Injectable } from "@angular/core";
import { LoginService } from "../service/login.service";
import { EnumPerfilUsuario } from "../model/usuario.model";
import { AuthorizeService } from "../service/authorize.service";

@Injectable()
export class RouteAnaliseGuard implements CanActivate {

    constructor(private loginService: LoginService,
                private authorizeService: AuthorizeService) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
        return this.checkAuthentication()
    }

    checkAuthentication(): boolean {
        const loggedIn = this.loginService.isLoggedIn();
        const usuario = this.loginService.usuario;
        if (!loggedIn) {
            window.location.href = "/";
       }
       
        const checked = loggedIn &&
            (this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_SISTEMA) ||
                this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_SEGURANCA_PACIENTE) ||
                this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_HOSPITAL) ||
                this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_NUCLEO) ||
                this.authorizeService.hasPerfil(EnumPerfilUsuario.INVESTIGADOR)
            );
        console.log("check Analise Guard", checked);
        return checked
    }

}